IREP.bottomdrawer = (function () {
    var options;
    var drawer;

    var init = function (drawerOptions) {
        options = drawerOptions;

        setupDrawer(options.drawerId);
        show(true);

        return this;
    };

    var show = function (addPadding) {
        options.container.slideDown({
            done: function () {
                setupDrawer(options.drawerId); 
                if (addPadding) {
                    $("#content").css("padding-bottom", "+=" + options.additionalPadding);
                }
            }
        });
    };

    var setupDrawer = function (drawerId) {
        var myDrawer = $("#" + drawerId);
        
        $(".btnCloseDetails").on("click", function () {
            options.container.hide();
            $("#overlay").hide();
        });
    };

    return {
        init: init,
        show: show
    };
})();